import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Header,
} from 'semantic-ui-react';
import _ from 'lodash';
import { numericRange } from '@mhub/web-validations';
import AppForm from '../../components/AppForm';
import { fetchM } from '../../actions/fetchM';
import { flashErrorMessage } from '../../actions/flash';

export default class NewUpdateIncomeForm extends Component {
  static propTypes = {
    customerID: PropTypes.string,
    data: PropTypes.shape({
      epfStatementDocumentID: PropTypes.string,
      epfStatementDocument: PropTypes.shape({
        key: PropTypes.string,
        tags: PropTypes.arrayOf(
          PropTypes.string,
        ),
      }),
      payslipDocumentID: PropTypes.string,
      payslipDocument: PropTypes.shape({
        key: PropTypes.string,
        tags: PropTypes.arrayOf(
          PropTypes.string,
        ),
      }),
      bankStatementDocumentID: PropTypes.string,
      bankStatementDocument: PropTypes.shape({
        key: PropTypes.string,
        tags: PropTypes.arrayOf(
          PropTypes.string,
        ),
      }),
      bFormDocumentID: PropTypes.string,
      bFormDocument: PropTypes.shape({
        key: PropTypes.string,
        tags: PropTypes.arrayOf(
          PropTypes.string,
        ),
      }),
    }),
    income: PropTypes.shape({
      id: PropTypes.string,
      isEmployed: PropTypes.bool,
      basicIncome: PropTypes.number,
      fixAllowance: PropTypes.number,
      grossIncome: PropTypes.number,
      deduction: PropTypes.number,
      netIncome: PropTypes.number,
      bYearlyIncome: PropTypes.number,
      otherYearlyIncome: PropTypes.number,
      currentLoanAmount: PropTypes.number,
    }),
    onChange: PropTypes.func,
    loading: PropTypes.bool,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static defaultValues = {
    bankStatementDocumentID: '',
    bankStatementDocument: null,
    basicIncome: 0,
    bFormDocumentID: '',
    bFormDocument: null,
    bYearlyIncome: 0,
    currentLoanAmount: 0,
    epfStatementDocumentID: '',
    epfStatementDocument: null,
    deduction: 0,
    fixAllowance: 0,
    grossIncome: 0,
    id: '',
    isEmployed: true,
    netIncome: 0,
    otherYearlyIncome: 0,
    payslipDocumentID: '',
    payslipDocument: null,
  }
  static getPropsToState = (props) => {
    const income = Object.assign({}, NewUpdateIncomeForm.defaultValues, props.income || {});
    return {
      income,
      oriIncome: Object.assign({}, income),
    };
  }
  constructor(props) {
    super(props);
    const state = NewUpdateIncomeForm.getPropsToState(props);
    this.state = {
      ...state,
      errMessages: [],
    };
    this.validation = {
      basicIncome: createRef(),
      fixAllowance: createRef(),
      deduction: createRef(),
      bYearlyIncome: createRef(),
      otherYearlyIncome: createRef(),
    };
  }
  componentDidMount() {
    this.fetchCustomerIncome();
  }
  componentWillReceiveProps(nextProps) {
    const state = NewUpdateIncomeForm.getPropsToState(nextProps);
    if (JSON.stringify(state.oriIncome) === JSON.stringify(this.state.oriIncome)) {
      state.income = this.state.income;
    }
    this.setState(state);
  }
  async fetchCustomerIncome() {
    const { store } = this.context;
    let res = '';
    try {
      res = await store.dispatch(fetchM(`/customers/${this.props.customerID}/income/${this.props.data.income.id}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      // await this.setLoading(false);
      Bugsnag.notifyException(err);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      return;
    }
    const json = await res.json();
    if (json) {
      const newIncome = Object.assign({}, json || {});
      this.setState({ income: newIncome });
    }
  }
  handleCheckChanges() {
    if (this.props.onChange) {
      const { income } = this.state;
      this.props.onChange(income);
    }
  }
  handleInputChange = (event, data) => {
    const { income } = this.state;
    income[data.name] = _.toNumber(data.value);
    if (income.isEmployed) {
      const grossIncome = _.toNumber(_.toNumber(income.basicIncome) + _.toNumber(income.fixAllowance)).toFixed(2);
      income.grossIncome = _.toNumber(grossIncome);
      const netIncome = _.toNumber(_.toNumber(income.grossIncome) - _.toNumber(income.deduction)).toFixed(2);
      income.netIncome = _.toNumber(netIncome);
    }
    if (!income.isEmployed) {
      const totalYearlyIncome = _.toNumber(income.bYearlyIncome) + _.toNumber(income.otherYearlyIncome);
      const totalMonthlyIncome = _.toNumber(totalYearlyIncome) / 12;
      const roughIncome = _.toNumber(totalMonthlyIncome).toFixed(2);
      income.netIncome = _.toNumber(roughIncome);
    }
    this.setState({ income }, () => {
      this.handleCheckChanges();
    });
  }
  render() {
    const { income } = this.state;
    return (
      <Grid centered>
        <Grid.Row>
          {
            income.isEmployed ? (
              <Grid.Column computer={7} tablet={9} mobile={16} textAlign="right">
                <AppForm.Input
                  label={
                    <Header
                      as="h5"
                      style={{ marginBottom: '0.5em' }}
                      textAlign="left"
                      content="Basic Monthly Income"
                      subheader="Monthly Basic Salary, Monthly Recurring Commission before any deduction"
                    />
                  }
                  validateLabel="Basic Monthly Income"
                  type="number"
                  step="0.01"
                  name="basicIncome"
                  value={income.basicIncome}
                  onChange={this.handleInputChange}
                  validation={income.isEmployed ? [{
                    validate: numericRange,
                    option: {
                      min: 1,
                      message: 'Basic Monthly Income is required',
                    },
                  }] : null}
                  ref={this.validation.basicIncome}
                />
                <AppForm.Input
                  label={
                    <Header
                      as="h5"
                      style={{ marginBottom: '0.5em' }}
                      textAlign="left"
                      content="Fix Monthly Allowance"
                      subheader="Recurring fixed travel allowance, meal allowance, yearly contractual bonus/12months"
                    />
                  }
                  validateLabel="Fix Monthly Allowance"
                  type="number"
                  step="0.01"
                  name="fixAllowance"
                  value={income.fixAllowance}
                  onChange={this.handleInputChange}
                  ref={this.validation.fixAllowance}
                />
                <Header
                  as="h5"
                  style={{ marginBottom: '0.5em' }}
                  textAlign="left"
                  content="Gross Monthly Income"
                />
                <AppForm.Input
                  type="number"
                  step="0.01"
                  name="grossIncome"
                  value={income.grossIncome}
                  disabled
                  readOnly
                />
                <AppForm.Input
                  label={
                    <Header
                      as="h5"
                      style={{ marginBottom: '0.5em' }}
                      textAlign="left"
                      content="Monthly Income deduction"
                      subheader="EPF, SOSCO, PCB, CP38"
                    />
                  }
                  validateLabel="Monthly Income deduction"
                  type="number"
                  step="0.01"
                  name="deduction"
                  value={income.deduction}
                  onChange={this.handleInputChange}
                  ref={this.validation.deduction}
                />
                <Header
                  as="h5"
                  style={{ marginBottom: '0.5em' }}
                  textAlign="left"
                  content="Net Monthly Income"
                />
                <AppForm.Input
                  type="number"
                  step="0.01"
                  name="netIncome"
                  value={income.netIncome}
                  validation={income.isEmployed ? [{
                    validate: numericRange,
                    option: {
                      min: 1,
                      message: 'Net Monthly Income is required',
                    },
                  }] :
                  null
                  }
                  disabled
                  readOnly
                />
              </Grid.Column>
            ) : null
          }
          {
            !income.isEmployed ? (
              <Grid.Column computer={7} tablet={9} mobile={16} textAlign="right">
                <AppForm.Input
                  label={
                    <Header
                      as="h5"
                      style={{ marginBottom: '0.5em' }}
                      textAlign="left"
                      content="Latest B Form Yearly Income"
                    />
                  }
                  validateLabel="Latest B Form Yearly Income"
                  type="number"
                  step="0.01"
                  name="bYearlyIncome"
                  value={income.bYearlyIncome}
                  onChange={this.handleInputChange}
                  validation={!income.isEmployed ? [{
                    validate: numericRange,
                    option: {
                      min: 1,
                      message: 'B Form Yearly Income is required',
                    },
                  }] : null}
                  ref={this.validation.bYearlyIncome}
                />
                <AppForm.Input
                  label={
                    <Header
                      as="h5"
                      style={{ marginBottom: '0.5em' }}
                      textAlign="left"
                      content="Other Yearly Income"
                    />
                  }
                  validateLabel="Other Yearly Income"
                  type="number"
                  step="0.01"
                  name="otherYearlyIncome"
                  value={income.otherYearlyIncome}
                  onChange={this.handleInputChange}
                  ref={this.validation.otherYearlyIncome}
                />
                <Header
                  as="h5"
                  style={{ marginBottom: '0.5em' }}
                  textAlign="left"
                  content="Total"
                />
                <AppForm.Input
                  type="number"
                  step="0.01"
                  name="netIncome"
                  value={income.netIncome}
                  validation={!income.isEmployed ? [{
                    validate: numericRange,
                    option: {
                      min: 1,
                      message: 'Total is required',
                    },
                  }] :
                  null
                  }
                  disabled
                  readOnly
                />
              </Grid.Column>
            ) : null
          }
        </Grid.Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/CreditCheck/NewUpdateIncomeForm.jsx